import React, { Component } from 'react';
import { injectIntl } from 'react-intl';
import Bind from 'lodash-decorators/bind';
import Debounce from 'lodash-decorators/debounce';
import { observer } from 'mobx-react';
import { observable } from 'mobx';

import styles from './Contact.module.scss';

import messages from './Contact.intl';

import { Container, Title } from 'common/components/Layout/Layout';
import OfficesStore from 'stores/Offices.store';
import { LOAD_STATES } from 'common/consts/common';

import Map from './Components/Map/Map';
import Form from './Components/Form/Form';
import DepartmentsList from 'common/components/DepartmentsList/DepartmentsList';

import ContentStore from 'stores/Content.store';
import InjectMetaTags from 'common/components/InjectMetaTags/InjectMetaTags';

import Placeholder from 'common/components/Placeholder/Placeholder';
import ContentBar from 'common/components/Placeholder/components/ContentBar/ContentBar';

import { isOnMobile } from 'utils/device-utils';

@injectIntl
@observer
export default class Contact extends Component {
  state = {
    loadState: LOAD_STATES.LOADING,
    activeDepartment: {},
    isMobile: isOnMobile()
  };

  mapLoaded = observable.box(false);
  contactFormRef = React.createRef();
  mapRef = React.createRef();

  async componentDidMount() {
    window.addEventListener('resize', this.updateDimensions);

    this.fetchOffices();

    if (this.props.location.state) {
      const { activeDepartmentID } = this.props.location.state;
      const office = await OfficesStore.getOfficeByID(activeDepartmentID);
      if (office) {
        this.setState({
          activeDepartment: office
        });
      }
    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateDimensions);
  }

  render() {
    const { activeDepartment } = this.state;

    const { offices, polishOffices, abroadOffices } = OfficesStore;
    const person = activeDepartment.contactPerson;

    return (
      <div>
        {ContentStore.isLoaded && (
          <InjectMetaTags {...ContentStore.content.contactSEO} />
        )}
        <Container>
          <div className={styles.HeaderBackground}>
            <Title
              title={this.props.intl.formatMessage(messages.heading)}
              className={styles.HeaderTitle}
            />
            <div className={styles.HeaderBox}>
              <h4 className={styles.HeaderSubtitle}>
                {this.props.intl.formatMessage(messages.contactWithUs)}
              </h4>
            </div>
          </div>
          <Form formRef={this.contactFormRef} person={person} />
        </Container>
        <Placeholder
          component={<ContentBar className={styles.MainContentPlaceholder} />}
          ready={this.mapLoaded.get()}
        />
        <Map
          offices={offices}
          activeDepartment={activeDepartment}
          onClick={this.onMarkerClick}
          setMapLoaded={this.setMapLoaded}
          mapLoaded={this.mapLoaded.get()}
          mapRef={this.mapRef}
        />
        <Container className={styles.OfficesContainer}>
          <DepartmentsList
            polishOffices={polishOffices}
            abroadOffices={abroadOffices}
            onClick={this.onDepartmentSet}
          />
        </Container>
      </div>
    );
  }

  @Bind()
  onDepartmentSet(department) {
    this.setState({
      activeDepartment: department
    });
    const target = this.state.isMobile
      ? this.mapRef.current
      : this.contactFormRef.current;

    this.scrollTo(target);
  }

  @Bind()
  onMarkerClick(department) {
    this.setState({
      activeDepartment: department
    });

    this.scrollTo(this.contactFormRef.current);
  }

  @Bind()
  scrollTo(node) {
    const elementPosition = node ? node.offsetTop : 0;
    window.scroll({ top: elementPosition, left: 0, behavior: 'smooth' });
  }

  async fetchOffices() {
    await OfficesStore.fetchOffices();

    this.setState({ loadState: LOAD_STATES.LOADED });
  }

  isLoaded() {
    return this.state.loadState === LOAD_STATES.LOADED;
  }

  @Bind()
  setMapLoaded() {
    this.mapLoaded.set(true);
  }

  @Bind()
  @Debounce(200)
  updateDimensions() {
    this.setState({
      isMobile: isOnMobile()
    });
  }
}



// WEBPACK FOOTER //
// ./src/views/Contact/Contact.js